export default "__VITE_ASSET__BPedGyUm__"